export const getValidSize = (propSize) => {
  // Fail fast if falsey
  if (!propSize) {
    // eslint-disable-next-line no-console
    console.error(`
    LDS Error: A Progress Indicator size prop was set to a falsey value.
    It will default to a size of 2.
    Please set a valid numeric size value to between 1.5 and 25.0 to clear this error.
    `);

    return 2;
  }

  let size = propSize;

  if (size < 1.5) {
    // eslint-disable-next-line no-console
    console.warn(`
    LDS Warning: A Progress Indicator size value was set to ${size} which is less than the minimum of 1.5.
    This restriction enforces visual readability and prevents useless excessive ensmallening of the element.
    The size value will be overridden to the minimum of 1.5.
    Please set a valid size value to between 1.5 and 25.0 to clear this warning.
    `);
    size = 1.5;
  }

  if (size > 25) {
    // eslint-disable-next-line no-console
    console.warn(`
    LDS Warning: A Progress Indicator size value was set to ${size} which is greater than the maximum of 25.0.
    This restriction prevents useless excessive embiggening of the element.
    The size will be overridden to the maximum of 25.
    Please set a valid size value to between 1.5 and 25.0 to clear this warning.
    `);
    size = 25;
  }

  return size;
};

export const getValidProgress = (propProgress) => {
  // Fail fast if falsey
  if (!propProgress) {
    // eslint-disable-next-line no-console
    console.error(`
    LDS Error: A Progress Indicator progress prop was set to a falsey value.
    It will default to a progress value of 0.
    Please set a valid numeric progress value to between 0 and 100 to clear this error.
    `);
    return 0;
  }

  let progress = propProgress;

  if (progress < 0) {
    // eslint-disable-next-line no-console
    console.warn(`
    LDS Warning: A Progress Indicator progress percentage value was set to ${progress}% which is invalid.
    The progress percent will be overridden to the minimum of 0.
    To correctly customize the value, please set it between 0-100 inclusive to clear this warning.
    `);
    progress = 0;
  }

  if (progress > 100) {
    // eslint-disable-next-line no-console
    console.warn(`
    LDS Warning: A Progress Indicator progress percentage value was set to ${progress}% which is invalid.
    The progress percent will be overridden to the maximum of 100.
    To correctly customize the value, please set it between 0-100 inclusive to clear this warning.
    `);
    progress = 100;
  }

  return progress;
};

export const getValidAriaLabel = (propAriaLabel) => {
  // Fail fast if falsey
  if (!propAriaLabel) {
    // eslint-disable-next-line no-console
    console.error(`
    LDS Error: A Progress Indicator ariaLabel prop was set to a falsey value.
    It will default to a value of "Progress".
    Please set a valid string value to clear this error.
    `);

    return 'Progress';
  }

  let ariaLabel = propAriaLabel;

  return ariaLabel;
};

export const getValidAriaValueMin = (propAriaValueMin) => {
  // Fail fast if falsey
  if (!propAriaValueMin) {
    // eslint-disable-next-line no-console
    console.error(`
    LDS Error: A Progress Indicator ariaValueMin prop was set to a falsey value.
    It will default to a value of 0.
    Please set a valid numeric value between 0 and 100 to clear this error.
    `);

    return 0;
  }

  let ariaValueMin = propAriaValueMin;

  if (ariaValueMin !== 0) {
    let warn = false;
    if (ariaValueMin < 0) {
      ariaValueMin = 0;
      warn = true;
    }
    if (ariaValueMin > 100) {
      ariaValueMin = 100;
      warn = true;
    }

    if (warn) {
      // eslint-disable-next-line no-console
      console.warn(`
      LDS Warning: A Progress Indicator has the ariaValueMin value set incorrectly; the value was either greater than 100 or less than 0 (zero).
      input ariaValueMin: ${propAriaValueMin}
      The ariaValueMin will be rendered as: ${ariaValueMin}
      To correctly customize the value, please set it between 0-100 inclusive to clear this warning.
      `);
    }
  }

  return ariaValueMin;
};

export const getValidAriaValueMax = (propAriaValueMax) => {
  // Fail fast if falsey
  if (!propAriaValueMax) {
    // eslint-disable-next-line no-console
    console.error(`
    LDS Error: A Progress Indicator ariaValueMax prop was set to a falsey value.
    It will default to a value of 100.
    Please set a valid numeric value between 0 and 100 to clear this error.
    `);

    return 100;
  }

  let ariaValueMax = propAriaValueMax;

  if (ariaValueMax !== 100) {
    let warn = false;
    if (ariaValueMax < 0) {
      ariaValueMax = 0;
      warn = true;
    }
    if (ariaValueMax > 100) {
      ariaValueMax = 100;
      warn = true;
    }

    if (warn) {
      // eslint-disable-next-line no-console
      console.warn(`
      LDS Warning: A Progress Indicator has the ariaValueMax value set incorrectly; the value was either greater than 100 or less than 0 (zero).
      input ariaValueMin: ${propAriaValueMax}
      The ariaValueMax will be rendered as: ${ariaValueMax}
      To customize the value, please set it between 0-100 inclusive to clear this warning.
      `);
    }
  }

  return ariaValueMax;
};

export const getProgressClasses = (progress) => {
  if (progress >= 100) return 'progress-complete';

  if (progress > 0 && progress < 100) {
    if (progress < 10) return 'progress-incomplete progress-0';
    if (progress < 20) return 'progress-incomplete progress-10';
    if (progress < 30) return 'progress-incomplete progress-20';
    if (progress < 40) return 'progress-incomplete progress-30';
    if (progress < 50) return 'progress-incomplete progress-40';
    if (progress < 60) return 'progress-incomplete progress-50';
    if (progress < 70) return 'progress-incomplete progress-60';
    if (progress < 80) return 'progress-incomplete progress-70';
    if (progress < 90) return 'progress-incomplete progress-80';
    if (progress < 100) return 'progress-incomplete progress-90';
  }

  return undefined;
};
